import { render, staticRenderFns } from "./pageheader.html?vue&type=template&id=69bf5e4b&scoped=true&"
import script from "./pageheader.js?vue&type=script&lang=js&"
export * from "./pageheader.js?vue&type=script&lang=js&"
import style0 from "./pageheader.scss?vue&type=style&index=0&id=69bf5e4b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bf5e4b",
  null
  
)

export default component.exports